import moment from 'moment-timezone'

const getNextDate = (_period = '15m', timeZone) => {
  const period = {
    '1m': [1, 'm'],
    '15m': [15, 'm'],
    '1h': [1, 'h'],
    '1d': [1, 'd'],
  }[_period]

  let time = moment()
  switch (_period) {
    case '1m':
      break

    case '15m':
      time.minute(
        Math.trunc(
          moment()
            .subtract(1, 's')
            .minute() / period[0]
        ) * period[0]
      )
      break

    case '1h':
      time
        .hour(
          Math.trunc(
            moment()
              .subtract(1, 's')
              .hour()
          )
        )
        .minute(0)
      break

    case '1d':
      time
        .day(
          Math.trunc(
            moment()
              .subtract(1, 's')
              .day()
          )
        )
        .hour(0)
        .minute(0)
      break

    default:
      break
  }

  return Math.trunc(
    time
      .second(0)
      .millisecond(0)
      .valueOf() /
      1000 +
      timeZone
  )
}

export default getNextDate
